module.exports = __webpack_public_path__ + "static/img/bg.807eda1a.png";